var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckBag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 24,
    viewBox: "0 0 23 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.7508 20.1667H7.33407C3.64907 20.1667 2.98907 18.6908 2.79657 16.8942L2.10907 9.56083C1.86157 7.32417 2.50324 5.5 6.4174 5.5H15.5841C19.4982 5.5 20.1399 7.32417 19.8924 9.56083L19.5993 12.6873",
    stroke: "#4E3E91",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.33398 5.49967V4.76634C7.33398 3.14384 7.33398 1.83301 10.2673 1.83301H11.734C14.6673 1.83301 14.6673 3.14384 14.6673 4.76634V5.49967",
    stroke: "#4E3E91",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8452 10.083L12.8327 12.8513H9.16602L2.29102 10.083",
    stroke: "#4E3E91",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1412 21.2014C19.8416 21.2014 21.22 19.823 21.22 18.1227C21.22 16.4223 19.8416 15.0439 18.1412 15.0439C16.4409 15.0439 15.0625 16.4223 15.0625 18.1227C15.0625 19.823 16.4409 21.2014 18.1412 21.2014Z",
    stroke: "#4E3E91",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9375 22.8199L20.5 21.2227",
    stroke: "#4E3E91",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckBag);
export default __webpack_public_path__ + "static/media/check-bag.a436c0524554429cf09d15d0df6f81c6.svg";
export { ForwardRef as ReactComponent };